import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { v4 } from "uuid";
import { BrowserTabContextProvider } from "./context/index.jsx";
import { usePageVisibility } from "../Hooks/usePageVisibility.jsx";

export const BrowserTabProvider = ({ children }) => {
  const randomKey = useMemo(() => v4(), []);
  const isVisible = usePageVisibility();
  const [value, setInternalValue] = useState(randomKey);

  React.useEffect(() => {
    if (isVisible) {
      setInternalValue(randomKey);
      localStorage.setItem("tabKey", randomKey);
    }
  }, [randomKey, isVisible]);

  React.useEffect(() => {
    const handleUnload = () => {
      if (value === randomKey) {
        localStorage.removeItem("tabKey");
      }
    };

    //when main tab closes, remove item from localStorage
    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("unload", handleUnload);
    };
  }, [randomKey, value]);

  React.useEffect(() => {
    const handleStorageUpdate = (evt) => {
      if (evt.key === "tabKey") {
        if (evt.newValue === null) {
          if (localStorage.getItem("tabKey") === null) {
            setInternalValue(randomKey);
            localStorage.setItem("tabKey", randomKey);
          }
        } else {
          setInternalValue(null);
        }
      }
    };

    //when non-main tabs receive the "close" event,
    //the first one will set the `tabKey` to its `randomKey`
    window.addEventListener("storage", handleStorageUpdate);

    return () => {
      window.removeEventListener("storage", handleStorageUpdate);
    };
  }, [randomKey]);

  return (
    <BrowserTabContextProvider value={{ isVisible, isLastActive: value === randomKey }}>
      {children}
    </BrowserTabContextProvider>
  );
};

BrowserTabProvider.propTypes = {
  children: PropTypes.node,
};
